'use strict';
var BASWebServices;
(function (BASWebServices) {
    var RandomSelect = (function () {
        function RandomSelect() {
        }
        RandomSelect.Factory = function () {
            return function (input) {
                if (angular.isArray(input)) {
                    var randomNumber = Math.floor(Math.random() * input.length);
                    console.error("NEVER USE THIS RANDOMIZATION FILTER... IT WILL UPDATE THE RESULT EVERY TIME AND ANGULAR WILL KEEP CHECKING UNTIL IT DOES NOT ANYMORE");
                    return input[randomNumber];
                }
                else {
                    return input;
                }
            };
        };
        return RandomSelect;
    }());
    BASWebServices.RandomSelect = RandomSelect;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=RandomSelect.js.map